import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-soma-bg flex items-center justify-center px-6">
      <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}
        className="text-center max-w-lg" data-testid="payment-cancel-page">
        <XCircle className="w-14 h-14 text-soma-muted mx-auto mb-8" strokeWidth={1.5} />
        <h1 className="font-display font-bold text-4xl mb-3">Checkout cancelled</h1>
        <p className="text-soma-muted mb-10">No charge was made. You can pick up where you left off whenever you're ready.</p>
        <Link to="/programs" className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-soma-primary text-soma-bg font-semibold hover:bg-soma-primaryHover transition-colors">
          Back to programs
        </Link>
      </motion.div>
    </div>
  );
}
